import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIndicator = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 21.813 19.077",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m0 9.451.21-.32c3.06-3.02 6.04-6.12 9.15-9.08.22-.17.65.12.65.35v5.05h11.48a.58.58 0 0 1 .32.45l-.02 7.39a.52.52 0 0 1-.38.34h-11.4v5.05a2 2 0 0 1-.14.26.48.48 0 0 1-.71-.05L.15 9.881 0 9.671v-.21Z" })
});
export default SvgIndicator;
